export enum NotificationSort {
    Title = 1,
    ValidFrom = 2,
    PutOnTop = 3,
    Roles = 4,
    IsActive = 5    
}